import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface Step {
  id: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

interface StickyStepperProps {
  steps: Step[];
  activeStep: string;
  onStepChange: (stepId: string) => void;
  getCurrentStepIndex: () => number;
}

export function StickyStepper({ steps, activeStep, onStepChange, getCurrentStepIndex }: StickyStepperProps) {
  return (
    <div className="sticky top-0 z-10 bg-background pb-4">
      <Card className="shadow-md">
        <CardContent className="p-4">
          <div className="flex items-center justify-between overflow-x-auto">
            {steps.map((step, index) => {
              const Icon = step.icon;
              const isActive = step.id === activeStep;
              const isCompleted = getCurrentStepIndex() > index;
              
              return (
                <div key={step.id} className="flex items-center">
                  <button
                    onClick={() => onStepChange(step.id)}
                    className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors whitespace-nowrap ${
                      isActive 
                        ? 'bg-primary text-primary-foreground' 
                        : isCompleted 
                        ? 'bg-green-100 text-green-700 dark:bg-green-900/20 dark:text-green-400'
                        : 'text-muted-foreground hover:bg-muted'
                    }`}
                    data-testid={`step-${step.id}`}
                  >
                    {isCompleted ? (
                      <CheckCircle className="w-5 h-5" />
                    ) : (
                      <Icon className="w-5 h-5" />
                    )}
                    <span className="font-medium">{step.label}</span>
                  </button>
                  {index < steps.length - 1 && (
                    <div className="w-8 h-px bg-border mx-2 flex-shrink-0" />
                  )}
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
